import { render, staticRenderFns } from "./packSearch.vue?vue&type=template&id=2254b684&"
import script from "./packSearch.vue?vue&type=script&lang=js&"
export * from "./packSearch.vue?vue&type=script&lang=js&"
import style0 from "./packSearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports